import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Modal } from 'antd';
import { useFetch } from './useFetch';
import { IListResponse } from '../types/list';
import { IPredefinedOrderMember } from '../types/predefined-order-member';

export const usePredefinedOrderMembers = () => {
    const deleteFetch = useFetch();
    const fetch = useFetch();
    const [response, setResponse] = useState<IListResponse<IPredefinedOrderMember>>();
    const [searchParams] = useSearchParams();
    const { t } = useTranslation();

    const page = searchParams.get('page');

    const deleteRow = (id: number) => {
        Modal.confirm({
            title: t('confirmAction'),
            content: t('deleteConfirmation'),
            onOk: () => deleteFetch.request({
                url: `/predefined-order-members/${id}/delete`,
                method: 'get',
            }).then(() => getList()),
            okText: t('delete'),
        });
    };

    const getList = async () => {
        let url = '/predefined-order-members';

        if (typeof page === 'string') {
            url += `?page=${page}`;
        }

        const result = await fetch.request({
            url,
            method: 'post',
            data: {
                sorters: [{ column: 'id', desc: true }],
            },
        });

        if (result.success) {
            setResponse(result.data);
        }
    };

    useEffect(() => {
        getList();
    }, [page]);

    return {
        response,
        deleteRow,
        loading: fetch.loading,
    };
};
